import {
  DOCUMENT,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  type OnDestroy,
  type OnInit,
  Output,
  inject,
} from '@angular/core';

@Directive({
  selector: '[closeIfOutsideClick]',
})
export class CloseIfOutsideClickDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef);
  private document = inject(DOCUMENT);

  @Input() ignoreEventsFrom: string[];

  @Output() outsideClick = new EventEmitter();

  private clickHandler = (event: any) => {
    const target = event.target;
    const wasOutsideClick = !this.el.nativeElement.contains(target);
    if (wasOutsideClick && !this.fromIgnored(target)) {
      this.outsideClick.emit();
    }
  };

  ngOnInit() {
    this.document.addEventListener('click', this.clickHandler);
  }

  ngOnDestroy() {
    this.document.removeEventListener('click', this.clickHandler);
  }

  private fromIgnored(target: any): boolean {
    if (!target || target.tagName === 'BODY' || !this.ignoreEventsFrom) {
      return false;
    }

    if (this.ignoreEventsFrom.includes(target.tagName?.toLowerCase())) {
      return true;
    }

    return this.fromIgnored(target.parentNode);
  }
}
